import { Injectable } from '@angular/core';
import { filter, find, map, mergeMap, retryWhen, startWith, switchMap } from 'rxjs/operators';
import { Driver } from '../drivers/driver';
import { combineLatest, interval, Observable, timer } from 'rxjs';
import { Ranking } from '../../season/rankings/ranking';
import { RacesService } from '../../season/races/races.service';
import { DriversService } from '../drivers/drivers.service';
import { RankingsService } from '../../season/rankings/rankings.service';
import { HttpClient } from '@angular/common/http';
import { RacePlan } from '../../season/race-plan/race-plan';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResultsImportService {

  public readonly racePlans$: Observable<RacePlan[]> = this.racesService.racePlans$;

  constructor(
    private racesService: RacesService,
    private driversService: DriversService,
    private rankingsService: RankingsService,
    private http: HttpClient
  ) {
  }

  loadRace$(racePlanId?: RacePlan['_id']): Observable<[RacePlan, Ranking[], Observable<Driver[]>]> {
    let racePlan$: Observable<RacePlan>;
    if (racePlanId) {
      racePlan$ = this.racePlans$.pipe(
        switchMap(racePlans => racePlans),
        find(racePlan => racePlan._id === racePlanId)
      );
    } else {
      racePlan$ = this.racePlans$.pipe(
        filter(racePlans => !!racePlans?.length),
        mergeMap(racePlans => racePlans.reverse()),
        find(racePlan => !!racePlan.resultsCouchDbName)
      );
    }
    return combineLatest([
      racePlan$,
      this.rankingsService.rankings$
    ]).pipe(
      map(([racePlan, rankings]: [RacePlan, Ranking[]]) => ([
        racePlan,
        rankings,
        this.driversService.requestDrivers$(racePlan, {pollingInterval: 10 * 1000})
      ]))
    );
  }

  createRemoteRawTagReadingsWatcher$(url: string, intervalPeriod = 2000): Observable<string> {
    let tailBytes = ('tagReadingsURLPollingTailBytes' in environment) ? environment.tagReadingsURLPollingTailBytes : null;
    return interval(intervalPeriod).pipe(
      startWith(-1),
      switchMap((i) => {
        return this.http.get(url, {
          responseType: 'text',
          // headers: tailBytes !== null && i >= 0 ? { 'Range': 'bytes=-' + ('' + tailBytes) } : {}
        }).pipe(
          retryWhen(errors => errors.pipe(
            mergeMap((error, retryCount) => {
              console.warn(error);
              const delayTime = 5000;
              console.log(`Retry ${retryCount + 1} after ${delayTime}ms`);
              return timer(delayTime);
            })
          ))
        );
      })
    );
  }
}
